<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2 col-xl-12 offset-xl-0">
        <div class="align-items-start row">
          <div class="col-12 col-xl-3 filter-group-wrapper">
            <ul class="unstyled row">
              <filter-group v-for="filterGroup in filters" :key="filterGroup.id" :filter-group="filterGroup"/>
            </ul>
          </div>
          <div class="col-12 col-xl-6">
            <post v-for="post in filteredPosts"
                  :key="post.id"
                  :filters="post.filters"
                  :link="post.link"
                  :title="post.title"
                  :lead="post.lead"
                  :has_content="post.has_content"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" @click="activeGroup = null" v-if="activeGroup !== null"></div>
  </div>
</template>

<script>
import Post from "./Post";
import FilterGroup from "./FilterGroup";

export default {
  data() {
    return {
      activeGroup: null,
      activeFilters: [],
    }
  },
  props: {
    'posts': Array,
    'filters': Array,
  },
  computed: {
    filteredPosts() {
      return this.posts.filter(post => {
        let isActive = false;

        if (this.activeFilters.length === 0) {
          return true;
        }

        post.filters.forEach(filter => {
          if (this.activeFilters.includes(filter.id)) {
            isActive = true;
          }
        });

        return isActive
      });
    }
  },
  methods: {
    toggleFilterGroup(id) {
      if (this.activeGroup === id) {
        this.activeGroup = null;
        return;
      }

      this.activeGroup = id;
    },
    filterChange(filter) {
      if (this.activeFilters.includes(filter)) {
        this.activeFilters = this.activeFilters.filter(item => item !== filter);
        return;
      }
      this.activeFilters.push(filter);
    }
  },
  components: {FilterGroup, Post},
}
</script>
